import React, { memo } from 'react'

import { AngleIcon } from '../Icons'

export interface IItemSwitcherProps {
  currentItem: number
  itemsCount: number
  onChange: (item: number) => void
  isLooped?: boolean
  disabled?: boolean
}

const ItemSwitcher: React.FC<IItemSwitcherProps> = memo(
  ({ currentItem, itemsCount, onChange, isLooped, disabled }) => {
    const handlePrevious = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      e.preventDefault()
      onChange(-1)
    }
    const handleNext = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      e.preventDefault()
      onChange(+1)
    }

    return (
      <div
        className={`flex gap-2 align-center justify-between ${
          disabled ? 'disabled' : ''
        }`}
      >
        <button
          type="button"
          className="w-7 h-7 text-white tc-mv-blur-4 rounded-full"
          onClick={handlePrevious}
          disabled={(!isLooped && currentItem - 1 === 0) || disabled}
        >
          <span className="flex items-center justify-center">
            <AngleIcon size={12} />
          </span>
        </button>
        <span
          className="text-white text-sm leading-7"
          data-testid="card-index-label"
        >
          {currentItem} /{itemsCount}
        </span>
        <button
          type="button"
          className="w-7 h-7 text-white tc-mv-blur-4 rounded-full"
          onClick={handleNext}
          disabled={(!isLooped && currentItem === itemsCount) || disabled}
        >
          <span className="flex items-center justify-center transform rotate-180">
            <AngleIcon size={12} />
          </span>
        </button>
      </div>
    )
  },
)

export { ItemSwitcher }
